import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setConfigData } from "../redux/slices/configData";
import useGetLandingPage from "../api-manage/hooks/react-query/useGetLandingPage";
import { getCookie } from "../helper-functions/getCookie";

const useConfigData = () => {
  const [loading, setLoading] = useState(true);
  const [localConfigData, setLocalConfigData] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const { data, refetch } = useGetLandingPage();
  
  // Get config data from Redux store
  const reduxConfigData = useSelector((state) => state.configData.configData);

  // Fetch config data if not available
  useEffect(() => {
    const fetchConfigData = async () => {
      // If we already have config data in Redux, use it
      if (reduxConfigData) {
        setLocalConfigData(reduxConfigData);
        setLoading(false);
        return;
      }

      // If no config data, fetch it
      const language = getCookie('languageSetting') || 'en';
      
      try {
        const configRes = await fetch(
          `${process.env.REACT_APP_BASE_URL || 'https://admin.alot263.com'}/api/v1/config`,
          {
            method: 'GET',
            headers: {
              'X-software-id': 33571750,
              'X-server': 'server',
              'X-localization': language,
              origin: process.env.REACT_APP_CLIENT_HOST_URL || 'https://alot263.com',
              'Content-Type': 'application/json',
            },
          }
        );

        if (configRes.ok) {
          const config = await configRes.json();
          setLocalConfigData(config);
          dispatch(setConfigData(config));
        }
      } catch (error) {
        console.error('Error fetching config data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchConfigData();
  }, [reduxConfigData, dispatch]);

  useEffect(() => {
    if (data) {
      setLoading(false);
    }
  }, [data]);

  // For non-root routes, don't show loading state
  const shouldShowLoading = location.pathname === '/' ? loading : false;

  return {
    configData: localConfigData || reduxConfigData,
    landingPageData: data,
    loading: shouldShowLoading,
    refetch,
  };
};

export default useConfigData;
